// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"b473cf04","893":"7e9e4f79"}[chunkId] + ".js";
};